import messages from './Structure.json'
import BtnRetour from 'src/components/Dashboard/Layout/BtnRetour/BtnRetour.vue'

export default {
  name: "Structure",

  i18n: messages,

  components: {
    BtnRetour
  },


  data() {
    return {
      form: {
        id: null,
        typeStructure: '',
        structureParent: null,
        nom: null
      },
      data: {
        typeStructure: null,
        structuresParent: null,
        structure: {
          id: null
        }
      },
      modeEdition: (this.$route.params.idStructure) ? true : false,

      // Gestion IHM
      controls: {
        form: {
          structureParentEnable: false
        }
      }
    }
  },

  mounted() {
    this.updateData();
  },

  methods: {

    updateData() {
      // 1. Récupère la liste des types de structure accessibles à l'utilisateur
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.get('rest/bd/typestructure/me').then(
        response => {
          this.data.typeStructure = response.data
          if (this.$val.isDefined(this.$route.params.idStructure)) {
            this.edition()
          }
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
        error => {
          this.$notify.error({
            title: this.$t('notifications.error.title'),
            message: this.$t('notifications.error.message')
          })
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        }
      )
    },

    // 2. En mode edition d'une structure, on pré-rempli le formulaire
    edition() {
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.get('rest/bd/structure/' + this.$route.params.idStructure).then(
        response => {
          this.data.structure = response.data
          this.form.id = response.data.id
          this.form.nom = response.data.nom
          this.form.typeStructure = response.data.type.id
          this.getParents(response.data.type.id);
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
        error => {
          this.$notify.error({
            title: this.$t('notifications.error.title'),
            message: this.$t('notifications.error.message')
          })
        }
      )
    },

    /**
     * Vérifie si une structure de même nom n'existe pas déjà
     * @param {*} nom
     */
    checkIfNameExist(nom) {
      this.$axios.get("/rest/bd/structure/nom/" + nom).then(
        response => {
          if (response.data.nom) {
            // Déjà utilisé
            //this.errors.remove('nom')
            const field = this.$validator.fields.find({
              name: 'nom',
              scope: this.$options.scope
            });
            this.$validator.errors.add({
              id: field.id,
              field: 'nom',
              msg: this.$t('form.champs.nom.label') + ' ' + response.data.nom + ' ' + this.$t('form.champs.nom.used'),
              scope: this.$options.scope,
            });

          } else {
            this.errors.remove('nom')
          }
        }
      )
    },

    getParents(idTypeStructure) {
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.get('rest/bd/structure/parent/' + idTypeStructure).then(
        response => {
          this.data.structuresParent = response.data.id
          this.controls.form.structureParentEnable = true
          switch (response.data.length) {
            case 0:
              // Problème configuration => alerte IHM
              this.$notify.error({
                title: this.$t('notifications.noParent.title'),
                message: this.$t('notifications.noParent.message')
              })
              this.form.structureParent = null
              this.controls.form.structureParentEnable = false
              break;
            case 1:
              // 1 seul élément => sélectionné par défaut
              this.data.structuresParent = response.data
              this.form.structureParent = response.data[0].id
              this.controls.form.structureParentEnable = false
              break;
            default:
              if (this.data.structure !== null ) {
                this.form.structureParent = this.data.structure.parent;
              }
              if (this.data.structure === null ) {
                this.form.structureParent = null
              }
              this.data.structuresParent = response.data
              this.controls.form.structureParentEnable = true
              break;
          }
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
        error => {
          this.$notify.error({
            title: this.$t('notifications.error.title'),
            message: this.$t('notifications.error.message')
          })
        }
      )
    },

    enregistrer() {
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          return;
        }
        let sp = this.data.structuresParent
        // Récupération de l'objet parent
        let parent = null;
        if (sp !== null) {
          if(this.form.structureParent.id) {
            parent = {
              'id': this.form.structureParent.id
              }
          } else {
            parent = {
              'id': this.form.structureParent
              } 
            }
        }
        
        // Construction de la request
        const structureDTO = {
          'id': this.form.id,
          'nom': this.form.nom,
          'type': {
            'id': this.form.typeStructure
          },
          'parent': parent
        };

        // Création ou update
        if (this.form.id) {
          // Appel au WS d'ajout structure
          this.$axios.put('/rest/bd/structure', structureDTO).then(
            response => {
              this.$eventHub.$emit(this.$eventHub.SHOW_NOTIF, 'success', this.$t('notifications.succes.title'), null)
              this.reset();
            }, error => {
              this.$eventHub.$emit(this.$eventHub.SHOW_NOTIF, 'error', this.$t('notifications.error.title'), this.$t('notifications.error.message'))
            }
          )
        } else {
          // Appel au WS d'ajout structure
          this.$axios.post('/rest/bd/structure', structureDTO).then(
            response => {
              //on notifie l'erreur a l'utilisateur
              this.$notify.success({
                title: this.$t('notifications.succes.title')
              })
              this.reset();
            }, error => {
              this.$notify.error({
                title: this.$t('notifications.error.title'),
                message: this.$t('notifications.error.message')
              })
            }
          )
        }
      })
    },

    reset() {
      this.$router.push({
        path: '/pages/admin/listeStructures'
      })
    }
  }
}
